import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ROUTES } from '@futrli/shared-services';

export enum PREDICTIONS_SUB_PAGES_IDS {
  PREDICTIONS_INVOICES = 'predictions-invoices',
  PREDICTIONS_SALES = 'predictions-sales',
  PREDICTIONS_COSTS = 'predictions-costs',
  PREDICTIONS_EXPENSES = 'predictions-expenses',
  PREDICTIONS_OTHER_P_AND_L = 'predictions-other-p-and-l',
  PREDICTIONS_ASSETS = 'predictions-assets',
  PREDICTIONS_LIABILITIES = 'predictions-liabilities',
  PREDICTION_PROFIT_LOSS = 'predictions-profit-and-loss',
  PREDICTION_BALANCE_SHEET = 'predictions-balance-sheet',
  PREDICTION_CASH_FLOW = 'predictions-cash-flow-statement'
}

export enum FORECAST_SUB_TAB_IDS {
  ASSETS = 'assets',
  COSTS = 'costs',
  EXPENSES = 'expenses',
  LIABILITIES = 'liabilities',
  OTHER_P_AND_L = 'other_p_and_l',
  SALES = 'sales'
}

export const FORECASTING_PAGES = [
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_INVOICES,
    route: ROUTES.INVOICES,
    linkComponent: <FormattedMessage id="predict.invoices" defaultMessage="Invoices" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_SALES,
    route: ROUTES.SALES,
    linkComponent: <FormattedMessage id="financial_fields.category.sales" defaultMessage="Sales" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_COSTS,
    route: ROUTES.COSTS,
    linkComponent: <FormattedMessage id="predict.predictions.costs" defaultMessage="Costs" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_EXPENSES,
    route: ROUTES.EXPENSES,
    linkComponent: <FormattedMessage id="financial_fields.category.expenses" defaultMessage="Expenses" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_OTHER_P_AND_L,
    route: ROUTES.OTHER_P_AND_L,
    linkComponent: <FormattedMessage id="predict.predictions.other_p_and_l" defaultMessage="Other P&L" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_ASSETS,
    route: ROUTES.ASSETS,
    linkComponent: <FormattedMessage id="predict.predictions.assets" defaultMessage="Assets" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_LIABILITIES,
    route: ROUTES.LIABILITIES,
    linkComponent: <FormattedMessage id="predict.predictions.liabilities" defaultMessage="Liabilities" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTION_PROFIT_LOSS,
    route: ROUTES.PROFIT_AND_LOSS,
    linkComponent: <FormattedMessage id="financial_fields.type.profit_and_loss" defaultMessage="Profit & Loss" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTION_BALANCE_SHEET,
    route: ROUTES.BALANCE_SHEET,
    linkComponent: <FormattedMessage id="financial_fields.type.balance_sheet" defaultMessage="Balance Sheet" />
  },
  {
    id: PREDICTIONS_SUB_PAGES_IDS.PREDICTION_CASH_FLOW,
    route: ROUTES.CASH_FLOW_STATEMENT,
    linkComponent: (
      <FormattedMessage id="predict.predictions.cash_flow_statement" defaultMessage="Cash Flow Statement" />
    )
  }
];

export const placeholdersWidths = {
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_SALES]: 47,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_COSTS]: 42,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_EXPENSES]: 66,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_OTHER_P_AND_L]: 68,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_ASSETS]: 46,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_LIABILITIES]: 67,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTION_PROFIT_LOSS]: 88,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTION_BALANCE_SHEET]: 96,
  [PREDICTIONS_SUB_PAGES_IDS.PREDICTION_CASH_FLOW]: 139
};
